<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'export.controls.cardTitle' | transloco }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'export.selectExportTypeBelow' | transloco }}</h6>

        <hr />

        <button
            class="btn btn-default mr-2 mb-2"
            (click)="download(ExportType.ControlAdvancedTestingHistory)"
        >
            {{ 'export.controls.changesInAdvancedButton' | transloco }}
        </button>
        @if (permService.permissions.IsDeveloperAdmin) {
            <hr />

            <mat-checkbox color="primary" name="includeMois" [(ngModel)]="includearchivedlinks"
                >{{ 'export.includeArchivedLinksCheckbox' | transloco }}</mat-checkbox
            >
            <hr />
            
            <button
                class="btn btn-default mr-2 mb-2"
                (click)="downloadControls(ExportType.ControlsForImport)"
                >
                {{ 'export.controls.exportForControlImportButton' | transloco }}
            </button>
        }
    </div>
</div>
